export enum MutationType {
  addPassedStep = 'ADD_PASSED_STEP',
  removeLastPassedStep = 'REMOVE_LAST_PASSED_STEP',
  setCurrentPage = 'SET_CURRENT_PAGE',
  setCurrentParams = 'SET_CURRENT_PARAMS',
}
